
const state = () => ({})

const getters = {}

const mutations = {}

const actions = {
  reset (context) {},
  paid (context) {},
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
